import { Progress, Space } from 'antd';
const SentenceProgress = ({per}) => {
  const percent = per[1]/per[2]*100
  const progressNum = per[1] < per[2] ? per[1] : per[2]
  return (
  <Space wrap>
    <Progress type="circle" percent={percent} format={()=>`${progressNum}/${per[2]}`}/>
  </Space>
  )
};
export default SentenceProgress;